///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.like_item_renaming = abcsetup.like_item_renaming || {};
abcsetup.like_item_renaming.index = abcsetup.like_item_renaming.index || {};



///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.like_item_renaming.index = {
    init: function() {
        $('#textSearchIdentifier').on('change', function(e) {
            if ($(this).val() == '') {
                $('#textSearch').attr('disabled', true);
            } else {
                $('#textSearch').attr('disabled', false);
            }
        });

        $('#resetBtn').on('click', function(e) {
            setTimeout(() => {
                /* clear the select2 boxes on reset */
                $(".select2-box").each(function() {
                    $(this).val([]).trigger('change');
                });
            }, 250);
        });

        $(document).on('click', '#submitButton', function(e) {
            e.preventDefault();

            abcsetup.alerts.confirm(
                "Submit Item Names?",
                "Are you sure you are ready to submit the item names that you entered for review? By clicking the green submit button, you confirm that you have <b>double checked your spelling, spacing & grammar</b> for each item being submitted.",
                function(resp) {
                    if (resp) {
                        $('#newNamesForm').submit();
                    }
                },
                "Confirm",
                "btn btn-success"
            );
        });

        $(document).on('click', '.reset-row-button', function(e) {
            $('#row-' + $(this).data('id')).find('input, select').each(function() {
                $(this).val($(this).data('original'));
            });
        });

        $(document).on('click', '#validateButton', function(e) {
            let passed = fieldValidate.runValidations($('input.lir_input'));

            if (passed && $('.invalid').length <= 0) {
                abcsetup.alerts.show("Validation Passed", "All form fields have validation.");
                $('#submitButton').removeAttr('disabled');
            } else {
                abcsetup.alerts.show("Validation Failed", "Please fill out all required fields.");
            }
        });
    },

    fieldError: function() {
        if ($('.invalid').length > 0) {
            $('#submitButton').attr('disabled', true)
        }
    }
}